import envorinment from "../services/server";
import receipt from "../services/receipt.js";
import { countries } from "../../src/utils/functions/constants";

const serverProvider = (isTestMode) => {
  const server = envorinment(isTestMode);

  return {
    getPageInformation: (id) => {
      return new Promise(async (resolve, reject) => {
        try {
          const server_response = await server.get(`/v1/info/${id}`).then((r) => r.data);
          resolve(server_response);
        } catch (error) {
          reject(error);
        }
      });
    },
    getInstallmentValues: (amount, doc, mid, _installments, minimun_value, payment) => {
      return new Promise(async (resolve) => {
        const payment_payload =
          Object.keys(payment).length !== 0
            ? {
                checkout_installment: payment,
              }
            : {};

        const payload = {
          installment_config: {
            minimum_installment_value: minimun_value,
            installments: _installments,
          },
          ...payment_payload,
        };

        const server_response = await server
          .post(`/v1/fps/${doc}/${mid}/${amount}`, payload)
          .then((r) => r.data)
          .catch((e) => {
            console.log("[e]", e);
            if (e.response) return e.response.data;
            return e;
          });

        resolve(server_response);
      });
    },
    getDeliveryData: (targer_cep, checkout_data) => {
      return new Promise(async (resolve, reject) => {
        try {
          const delivery_payload = {
            document_number: checkout_data.document_number,
            mid: checkout_data.mid,
            source_zipcode: checkout_data.shipping.source_zipcode,
            measures: checkout_data.shipping.measures,
          };

          const server_response = await server
            .post(`/v1/delivery/${targer_cep}`, delivery_payload)
            .then((r) => r.data);
          resolve(server_response.data);
        } catch (error) {
          reject(error);
        }
      });
    },
    createTransaction: (data, info, checkout, _mdd) => {
      return new Promise(async (resolve, reject) => {
        try {
          // aqui em cima montar o campo items
          const number_phone = info.phone.replace(/\D/g, "");
          const receive_number_phone = info.receiverPhone.replace(/\D/g, "");
          const number_document = info.document_number;
          const number_document_type =
            info.billingCountry !== "BRL" ? "OTHER" : number_document.length === 11 ? "CPF" : "CNPJ";

          const _items = checkout.cart
            ? {
                items: checkout.cart?.items.reduce((acc, elem, index) => {
                  return [
                    ...acc,
                    {
                      id: String(elem.id || index + 1),
                      title: elem.product_name || "",
                      unit_price: String(elem.product_price) || "",
                      sku: elem.product_sku || "",
                      description: elem.product_description || "",
                      quantity: elem.quantity ? String(elem.quantity) : "1",
                    },
                  ];
                }, []),
              }
            : {};

          const shipping =
            checkout.shipping && info.deliveryForm !== "without_shipping_pick_up"
              ? {
                  shipment: {
                    name: info.receiverName.split(" ")[0],
                    surname: info.receiverName.split(" ").slice(1).join(" "),
                    phones: [
                      {
                        number: receive_number_phone.slice(2),
                        ddd: receive_number_phone.slice(0, 2),
                        ddi: "55",
                      },
                    ],
                    address: {
                      street_name: info.deliveryAddress || "",
                      street_number: info.deliveryAddressNumber || "",
                      complement: info.deliveryComplement || "",
                      district: info.deliveryDistrict || "",
                      city: info.deliveryCity || "",
                      state: info.deliveryState || "",
                      country: info.deliveryCountry || "",
                      zip_code: info.deliveryCep.replace("-", "") || "",
                    },
                  },
                }
              : {};

          // indica se o pagamento tem juros
          const payment = data.interest_amount
            ? {
                authorizer_id: data.authorizerId,
                installment_data: {
                  use_mrpay_installment: "true",
                  original_amount: data.amount,
                },
                installmentCost: String(Number(data.interest_amount) - Number(data.amount)),
              }
            : {};

          const recurrent = checkout.payment?.recurrent_payment
            ? {
                store_identification: checkout.additional_data.payer.store_identification,
                recurrent: {
                  do_payment_now: String(checkout.payment.recurrent_payment.do_payment_now || ""),
                  payment_amount: data.amount,
                  initial_date: checkout.payment.recurrent_payment.initial_date || "",
                  number_of_times: String(checkout.payment.recurrent_payment.number_of_times || ""),
                  interval: String(checkout.payment.recurrent_payment.interval || ""),
                  soft_descriptor: data.recurrent_soft_descriptor,
                  show_times_invoice: String(
                    checkout.payment.recurrent_payment.show_times_invoice || ""
                  ),
                },
              }
            : {};

          const shipping_free =
            checkout.shipping?.type !== "free" && checkout.shipping?.type !== "without_shipping_pick_up"
              ? {
                  services: {
                    name: info.deliveryType[info.deliveryChoice]?.name || "",
                    price: Number(info.deliveryType[info.deliveryChoice]?.price || ""),
                    deadline: info.deliveryType[info.deliveryChoice]?.deadline || 0,
                  },
                }
              : {};

          const shipping_filled =
            checkout.shipping && checkout.shipping?.type !== "without_shipping_pick_up"
              ? {
                  checkout_filled: {
                    addressee: {
                      full_name: info.receiverName,
                      phone: info.receiverPhone,
                    },
                    ...shipping_free,
                  },
                }
              : {};

          const createTransactionPayload = {
            mrpay_api_id: checkout.mrpay_api_id,
            mrpay_api_key: checkout.mrpay_api_key,
            merchant_usn: checkout.merchant_usn || new Date().getTime().toString().substring(3),
            merchant_order_id:
              checkout.merchant_order_id || new Date().getTime().toString().substring(4),
            transaction_type: checkout.transaction_type || "payment",
            payment_installments: data.parcels,
            soft_descriptor: data.link_soft_descriptor,
            payment_amount: data.interest_amount || data.amount,
            auto_confirmation: data.confirmation,
            use_payer_authentication: String(data.authentication),
            use_antifraud: String(data.antifraud) || "false",
            discount: String(data.discount),
            freight: String(info.deliveryType[info.deliveryChoice]?.price || ""),
            ...payment,
            ...recurrent,
            payer_data: {
              name: info.identificationName.split(" ")[0],
              surname: info.identificationName.split(" ").slice(1).join(" "),
              email: info.email || "",
              phones: [
                {
                  number: number_phone.slice(2),
                  ddd: number_phone.slice(0, 2),
                  ddi: "55",
                },
              ],
              documents: [
                {
                  type: number_document_type,
                  number: number_document,
                },
              ],
              address: {
                street_name: info.billingAddress || "",
                street_number: info.billingAddressNumber || "",
                complement: info.billingComplement || "",
                district: info.billingDistrict || "",
                city: info.billingCity || "",
                state: info.billingState || "",
                country: info.billingCountry || "",
                zip_code: info.billingCep.replace("-", "") || "",
              },
            },
            ...shipping,
            ..._items,
            mdd: _mdd,
            checkout,
            ...shipping_filled,
            currency: "BRL",
          };

          const server_response = await server
            .post("/v1/payment/create", createTransactionPayload)
            .then((r) => r.data);
          resolve(server_response);
        } catch (e) {
          console.log("t - e", e);
          reject(e);
        }
      });
    },
    authorization: (
      { data, values: info, checkout_payload: checkout, mddValues: _mdd },
      authentication_code
    ) => {
      return new Promise(async (resolve, reject) => {
        try {
          const parts = info.identificationName.trim().split(/\s+/);
          const name = parts[0];
          const surname = parts.slice(1).join(" ");
          const number_phone = info.phone.replace(/\D/g, "");
          const receive_number_phone = info.receiverPhone.replace(/\D/g, "");
          const number_document = info.document_number.replace(/\D/g, "");
          const number_document_type =
            countries[info.billingCountry] !== "BR"
              ? "OTHER"
              : number_document.length === 11
              ? "CPF"
              : "CNPJ";

          const shipping_free =
            checkout.shipping?.type !== "free" && checkout.shipping?.type !== "without_shipping_pick_up"
              ? {
                  services: {
                    name: info.deliveryType[info.deliveryChoice]?.name || "",
                    price: Number(info.deliveryType[info.deliveryChoice]?.price || ""),
                    deadline: info.deliveryType[info.deliveryChoice]?.deadline || 0,
                  },
                }
              : {};

          const shipping_filled =
            checkout.shipping && checkout.shipping?.type !== "without_shipping_pick_up"
              ? {
                  checkout_filled: {
                    addressee: {
                      full_name: info.receiverName,
                      phone: info.receiverPhone,
                    },
                    ...shipping_free,
                  },
                }
              : {};

          const payload = {
            mrpay_api_id: checkout.mrpay_api_id,
            mrpay_api_key: checkout.mrpay_api_key,
            merchant_usn: checkout.merchant_usn || new Date().getTime().toString().substring(3),
            merchant_order_id:
              checkout.merchant_order_id || new Date().getTime().toString().substring(4),
            transaction_type: checkout.transaction_type || "payment",
            payment_installments: data.parcels,
            soft_descriptor: data.link_soft_descriptor,
            payment_amount: data.interest_amount || data.amount,
            auto_confirmation: data.confirmation,
            use_payer_authentication: String(data.authentication),
            use_antifraud: String(data.antifraud) || "false",
            discount: String(data.discount),
            freight: String(info.deliveryType[info.deliveryChoice]?.price || ""),
            authorizer_id: data.authorizerId,
            card: {
              number: data.cardNumber.replace(/ /g, ""),
              expiry_date: data.expiryMonth + data.expiryYear.substring(2),
              security_code: data.securityCode,
              holder: data.cardName,
            },
            payer_data: {
              name,
              surname,
              email: info.email || "",
              phones: [
                {
                  number: number_phone.slice(2),
                  ddd: number_phone.slice(0, 2),
                  ddi: "55",
                },
              ],
              documents: [
                {
                  type: number_document_type,
                  number: number_document,
                },
              ],
              address: {
                street_name: info.billingAddress || "",
                street_number: info.billingAddressNumber || "",
                complement: info.billingComplement || "",
                district: info.billingDistrict || "",
                city: info.billingCity || "",
                state: info.billingState || "",
                country: countries[info.billingCountry] || "",
                zip_code: info.billingCep.replace("-", "") || "",
              },
            },
            mdd: _mdd,
            checkout,
            ...shipping_filled,
            currency: "BRL",
          };

          if (authentication_code) {
            payload["external_authentication_code"] = authentication_code;
          }

          // indica se o pagamento tem juros
          if (data.interest_amount) {
            payload["authorizer_id"] = data.authorizerId;
            payload["installment_data"] = {
              use_mrpay_installment: "true",
              original_amount: data.amount,
            };
            payload["installmentCost"] = String(Number(data.interest_amount) - Number(data.amount));
          }

          if (checkout.cart) {
            payload["items"] = checkout.cart?.items.reduce((acc, elem, index) => {
              return [
                ...acc,
                {
                  id: String(elem.id || index + 1),
                  title: elem.product_name || "",
                  unit_price: String(elem.product_price) || "",
                  sku: elem.product_sku || "",
                  description: elem.product_description || "",
                  quantity: elem.quantity ? String(elem.quantity) : "1",
                },
              ];
            }, []);
          }

          if (checkout.shipping && info.deliveryForm !== "without_shipping_pick_up") {
            const receiver_parts = info.receiverName.trim().split(/\s+/);
            const receiver_name = receiver_parts[0];
            const receiver_surname = receiver_parts.slice(1).join(" ");

            payload["shipment"] = {
              name: receiver_name,
              surname: receiver_surname,
              phones: [
                {
                  number: receive_number_phone.slice(2),
                  ddd: receive_number_phone.slice(0, 2),
                  ddi: "55",
                },
              ],
              address: {
                street_name: info.deliveryAddress || "",
                street_number: info.deliveryAddressNumber || "",
                complement: info.deliveryComplement || "",
                district: info.deliveryDistrict || "",
                city: info.deliveryCity || "",
                state: info.deliveryState || "",
                country: countries[info.deliveryCountry] || "",
                zip_code: info.deliveryCep.replace("-", "") || "",
              },
            };
          }

          if (checkout.payment?.recurrent_payment) {
            payload["store_identification"] = checkout.additional_data.payer.store_identification;
            payload["recurrent"] = {
              do_payment_now: String(checkout.payment.recurrent_payment.do_payment_now || ""),
              payment_amount: data.amount,
              initial_date: checkout.payment.recurrent_payment.initial_date || "",
              number_of_times: String(checkout.payment.recurrent_payment.number_of_times || ""),
              interval: String(checkout.payment.recurrent_payment.interval || ""),
              soft_descriptor: data.recurrent_soft_descriptor,
              show_times_invoice: String(checkout.payment.recurrent_payment.show_times_invoice || ""),
            };
          }

          const server_response = await server.post("/v2/authorization", payload).then((r) => r.data);
          resolve(server_response);
        } catch (e) {
          console.log("t - e", e);
          reject(e);
        }
      });
    },
    createTransactionWithPix: (amount, checkout, info, data) => {
      return new Promise(async (resolve, reject) => {
        try {
          // aqui em cima montar o campo items
          const number_phone = info.phone.replace(/\D/g, "");
          const receive_number_phone = info.receiverPhone.replace(/\D/g, "");
          const number_document = info.document_number;
          const number_document_type =
            info.billingCountry !== "BRL" ? "OTHER" : number_document.length === 11 ? "CPF" : "CNPJ";

          const _items = checkout.cart
            ? {
                items: checkout.cart?.items.reduce((acc, elem, index) => {
                  return [
                    ...acc,
                    {
                      id: String(elem.id || index + 1),
                      title: elem.product_name || "",
                      unit_price: String(elem.product_price) || "",
                      sku: elem.product_sku || "",
                      description: elem.product_description || "",
                      quantity: elem.quantity ? String(elem.quantity) : "1",
                    },
                  ];
                }, []),
              }
            : {};

          const shipping =
            checkout.shipping && info.deliveryForm !== "without_shipping_pick_up"
              ? {
                  shipment: {
                    name: info.receiverName.split(" ")[0],
                    surname: info.receiverName.split(" ").slice(1).join(" "),
                    phones: [
                      {
                        number: receive_number_phone.slice(2),
                        ddd: receive_number_phone.slice(0, 2),
                        ddi: "55",
                      },
                    ],
                    address: {
                      street_name: info.deliveryAddress || "",
                      street_number: info.deliveryAddressNumber || "",
                      complement: info.deliveryComplement || "",
                      district: info.deliveryDistrict || "",
                      city: info.deliveryCity || "",
                      state: info.deliveryState || "",
                      country: info.deliveryCountry || "",
                      zip_code: info.deliveryCep.replace("-", "") || "",
                    },
                  },
                }
              : {};

          const shipping_free =
            checkout.shipping?.type !== "free" && checkout.shipping?.type !== "without_shipping_pick_up"
              ? {
                  services: {
                    name: info.deliveryType[info.deliveryChoice]?.name || "",
                    price: Number(info.deliveryType[info.deliveryChoice]?.price || ""),
                    deadline: info.deliveryType[info.deliveryChoice]?.deadline || 0,
                  },
                }
              : {};

          const shipping_filled =
            checkout.shipping && checkout.shipping?.type !== "without_shipping_pick_up"
              ? {
                  checkout_filled: {
                    addressee: {
                      full_name: info.receiverName,
                      phone: info.receiverPhone,
                    },
                    ...shipping_free,
                  },
                }
              : {};

          const createPixTransactionPayload = {
            mrpay_api_id: checkout.mrpay_api_id,
            mrpay_api_key: checkout.mrpay_api_key,
            merchant_order_id: checkout.merchant_order_id,
            payment_installments: "1",
            payment_amount: amount,
            discount: String(data.discount),
            freight: String(info.deliveryType[info.deliveryChoice]?.price || ""),
            payer_data: {
              name: info.identificationName.split(" ")[0],
              surname: info.identificationName.split(" ").slice(1).join(" "),
              email: info.email || "",
              phones: [
                {
                  number: number_phone.slice(2),
                  ddd: number_phone.slice(0, 2),
                  ddi: "55",
                },
              ],
              documents: [
                {
                  type: number_document_type,
                  number: number_document,
                },
              ],
              address: {
                street_name: info.billingAddress || "",
                street_number: info.billingAddressNumber || "",
                complement: info.billingComplement || "",
                district: info.billingDistrict || "",
                city: info.billingCity || "",
                state: info.billingState || "",
                country: info.billingCountry || "",
                zip_code: info.billingCep.replace("-", "") || "",
              },
            },
            ...shipping,
            ..._items,
            checkout,
            ...shipping_filled,
          };
          console.log("[createPixTransactionPayload]", createPixTransactionPayload);

          const server_response = await server
            .post("/v1/payment/create/pix", createPixTransactionPayload)
            .then((r) => r.data);
          resolve(server_response);
        } catch (e) {
          reject(e);
        }
      });
    },
    checkPixPayment: (nit, checkout) => {
      return new Promise(async (resolve, reject) => {
        try {
          const id = checkout.mrpay_api_id;
          const key = checkout.mrpay_api_key;
          const server_response = await server
            .get(`/v1/payment/pix/${id}/${key}/${nit}`)
            .then((r) => r.data);
          resolve(server_response);
        } catch (e) {
          reject(e);
        }
      });
    },
    transactionPayment: (nit, data, checkout) => {
      return new Promise(async (resolve, reject) => {
        // Tudo certo para request para o ecommerce
        try {
          const transactionPaymentPayload = {
            mrpay_api_id: checkout.mrpay_api_id,
            mrpay_api_key: checkout.mrpay_api_key,
            authorizer_id: data.authorizerId,
            card: {
              number: data.cardNumber.replace(/ /g, ""),
              expiry_date: data.expiryMonth + data.expiryYear.substring(2),
              security_code: data.securityCode,
              holder: data.cardName,
            },
          };

          const server_response = await server
            .post(`/v1/payment/pay/${nit}`, transactionPaymentPayload)
            .then((response) => {
              return response.data;
            })
            .catch((err) => {
              console.log("[err]", err);
              if (!err.response) throw new Error("Erro ao efetivar pagamento");
              if (!err.response.data.payment) reject(err.response.data);

              return err.response.data;
            });
          resolve(server_response);
        } catch (e) {
          reject(e);
        }
      });
    },
    preauthorizationPayment: (nit, data, checkout) => {
      return new Promise(async (resolve) => {
        const preauthorizationPaymentPayload = {
          mrpay_api_id: checkout.mrpay_api_id,
          mrpay_api_key: checkout.mrpay_api_key,
          installments: data.parcels,
          authorizer_id: data.authorizerId,
          card: {
            number: data.cardNumber.replace(/ /g, ""),
            expiry_date: data.expiryMonth + data.expiryYear.substring(2),
            security_code: data.securityCode,
            holder: data.cardName,
          },
        };

        const server_response = await server
          .post(`/v1/preauthorization/pay/${nit}`, preauthorizationPaymentPayload)
          .then((response) => response.data)
          .catch((err) => {
            if (err.response) return err.response.data;
            return err;
          });

        resolve(server_response);
      });
    },
    schedulePayment: (sid, data, checkout) => {
      return new Promise(async (resolve, reject) => {
        try {
          const scheduleActivationPayload = {
            mrpay_api_id: checkout.mrpay_api_id,
            mrpay_api_key: checkout.mrpay_api_key,
            authorizer_id: data.authorizerId,
            transaction_data: {
              auto_confirmation: data.confirmation,
            },
            card: {
              number: data.cardNumber.replace(/ /g, ""),
              expiry_date: data.expiryMonth + data.expiryYear.substring(2),
              security_code: data.securityCode,
              holder: data.cardName,
            },
          };

          const server_response = await server
            .post(`/v1/schedule/pay/${sid}`, scheduleActivationPayload)
            .then((response) => {
              return response.data;
            })
            .catch((err) => {
              console.log("[err]", err);
              if (!err.response) throw new Error("Erro ao efetivar pagamento");

              return err.response.data;
            });
          resolve(server_response);
        } catch (e) {
          reject(e);
        }
      });
    },
    confirmationPayment: (nit, confirmation, amount) => {
      return new Promise(async (resolve, reject) => {
        try {
          const body = { confirm: confirmation, payment_amount: amount };

          const server_response = await server.put(`/v1/payment/pay/${nit}`, body).then((r) => r.data);
          resolve(server_response);
        } catch (error) {
          reject(error);
        }
      });
    },
    getSetupData: ({ data, checkoutId }) => {
      return new Promise(async (resolve, reject) => {
        // Todos os campos do setup estão certos!
        try {
          const setup_payload = {
            mrpay_api_id: checkoutId.mrpay_api_id,
            mrpay_api_key: checkoutId.mrpay_api_key,
            card: {
              authorizer_id: data.authorizerId,
              number: data.cardNumber.replace(/\s/g, ""),
              expiry_date: data.expiryMonth + data.expiryYear.substring(2),
            },
          };

          const setup_response = await server
            .post("/v1/payment/redirect", setup_payload, {
              params: { to: `/v2/auth/setup`, method: "post" },
            })
            .then((resp) => resp.data);

          resolve(setup_response);
        } catch (e) {
          reject(e);
        }
      });
    },
    getEnrollmentData: ({ nit, data, checkoutId, info, checkout, reference_id }) => {
      return new Promise(async (resolve, reject) => {
        try {
          const parts = info.identificationName.trim().split(/\s+/);
          const name = parts[0];
          const surname = parts.slice(1).join(" ");

          const enrollment_payload = {
            mrpay_api_id: checkoutId.mrpay_api_id,
            mrpay_api_key: checkoutId.mrpay_api_key,
            merchant_order_id: checkout.merchant_order_id,
            merchant_usn: checkout.merchant_usn,
            payment_amount: data.interest_amount || data.amount,
            card: {
              authorizer_id: data.authorizerId,
              number: data.cardNumber.replace(/ /g, ""),
              expiry_date: data.expiryMonth + data.expiryYear.substring(2),
            },
            additional_data: {
              bill_to: {
                street1: info.billingAddress,
                street2: "",
                city: info.billingCity,
                state: info.billingState,
                country: countries[info.billingCountry],
                postal_code: info.billingCep,
                email: info.email,
                first_name: name,
                last_name: surname,
                phone_number: info.phone,
              },
              lineItems: checkout.cart.items.map((item) => {
                return {
                  totalAmount: String((item.quantity || 1) * item.product_price),
                  unitPrice: String(item.product_price),
                  quantity: String(item.quantity || 1),
                  productSKU: item.product_sku || "",
                  productDescription: item.product_description || "",
                  productName: item.product_name || "",
                };
              }),
              buyer_information: {
                mobile_phone: data.phone,
                merchant_customer_id: data.cpf,
              },
              device_information: {
                http_browser_language: window.navigator.language,
                http_browser_java_script_enabled: "Y",
                http_browser_color_depth: window.screen.colorDepth,
                http_browser_screen_height: window.screen.availHeight,
                http_browser_screen_width: window.screen.availWidth,
                http_browser_time_difference: new Date().getTimezoneOffset(),
              },
              consumer_authentication_information: {
                return_url: `${process.env.REACT_APP_SERVER_URL}/v1/mrpay/auth-callback`,
                reference_id: reference_id,
              },
            },
          };

          const enrollment_response = await server
            .post("/v1/payment/redirect", enrollment_payload, {
              params: { to: `/v2/auth/enrollment/${nit}`, method: "post" },
            })
            .then((resp) => resp.data);

          resolve(enrollment_response);
        } catch (error) {
          reject(error);
        }
      });
    },
    checkChallengeCompletation: (nit, checkout) => {
      return new Promise(async (resolve, reject) => {
        // tudo certo
        const body = {
          mrpay_api_id: checkout.mrpay_api_id,
          mrpay_api_key: checkout.mrpay_api_key,
        };

        try {
          const check_response = await server
            .post("/v1/payment/redirect", body, {
              params: {
                to: `/v2/auth/challengefinished/${nit}`,
                method: "get",
              },
            })
            .then((resp) => resp.data.challenge_finished);

          resolve(check_response);
        } catch (e) {
          console.log("[checkChallenger error]", e);
          reject(e);
        }
      });
    },
    getValidateData: (nit, transactionId, data, checkout) => {
      return new Promise(async (resolve, reject) => {
        // Todos os campos do validate estão certos!
        try {
          const validateBody = {
            mrpay_api_id: checkout.mrpay_api_id,
            mrpay_api_key: checkout.mrpay_api_key,
            payment_amount: data.interest_amount || data.amount,
            transaction_id: transactionId,
            card: {
              authorizer_id: data.authorizerId,
              number: data.cardNumber.replace(/ /g, ""),
              expiry_date: data.expiryMonth + data.expiryYear.substring(2),
            },
          };

          const validate_response = await server
            .post("/v1/payment/redirect", validateBody, {
              params: { to: `/v2/auth/validate/${nit}`, method: "post" },
            })
            .then((resp) => resp.data);

          resolve(validate_response);
        } catch (error) {
          reject(error);
        }
      });
    },
    createReceipt: (payload) => {
      return new Promise(async (resolve, reject) => {
        try {
          const receipt_response = await receipt.post(`/checkout/receipt`, payload).then((r) => r.data);
          resolve(receipt_response);
        } catch (error) {
          reject(error);
        }
      });
    },
    verifyCaptchaToken: (token) => {
      return new Promise(async (resolve, reject) => {
        try {
          const setup_response = await server.get(`/v1/captcha/${token}`, {}).then((resp) => resp.data);

          resolve(setup_response);
        } catch (error) {
          reject(error);
        }
      });
    },
  };
};

export default serverProvider;
